export default "__VITE_ASSET__JbuanM7s__"